import React from "react";
import "./ConfirmCard.css";

// One confirm-card for system-proposed items a human confirms/rejects.
// Backs receipt lines now; the same shell can render agent ProposedActions
// (title/reason/evidence/confidence + confirm-reject actions are the same shape).
//
// props:
//   title, subtitle
//   meta:        [{ label, value }]        small key/value chips
//   confidence:  0..1 (optional)           renders a confidence chip
//   badge:       { text, tone }            tone: 'match' | 'new' | 'ok' | 'warn'
//   state:       'pending' | 'confirmed' | 'rejected'
//   actions:     [{ label, variant, onClick, disabled }]  variant: 'primary'|'ghost'|'danger'
export default function ConfirmCard({ title, subtitle, meta = [], confidence, badge, state = "pending", actions = [] }) {
  return (
    <div className={`cc-item cc-item--${state}`}>
      <div className="cc-item__head">
        <div className="cc-item__title">{title}</div>
        {badge && <span className={`cc-badge cc-badge--${badge.tone || "ok"}`}>{badge.text}</span>}
      </div>
      {subtitle && <div className="cc-item__subtitle">{subtitle}</div>}
      {(meta.length > 0 || confidence != null) && (
        <div className="cc-meta">
          {meta.map((m) => (
            <span key={m.label} className="cc-chip"><em>{m.label}</em> {m.value}</span>
          ))}
          {confidence != null && (
            <span className="cc-chip cc-chip--conf">{Math.round(confidence * 100)}% match</span>
          )}
        </div>
      )}
      {state === "pending" && actions.length > 0 && (
        <div className="cc-actions">
          {actions.map((a) => (
            <button
              key={a.label}
              className={`cc-btn cc-btn--${a.variant || "ghost"}`}
              onClick={a.onClick}
              disabled={a.disabled}
            >
              {a.label}
            </button>
          ))}
        </div>
      )}
      {state !== "pending" && (
        <div className={`cc-state cc-state--${state}`}>{state === "confirmed" ? "Confirmed" : "Rejected"}</div>
      )}
    </div>
  );
}
